/* eslint-disable */

const PREVIEW_URL = "http://preview.spotlyte.mwkci.ventures";

function get_preview_url(MODEL_TYPE, ITEM_ID, Item_Value) {
  const PREVIEW_URL = generateURL(MODEL_TYPE, ITEM_ID, Item_Value);
  return PREVIEW_URL;
}

function generateURL(MODEL_TYPE, ITEM_ID, Item_Value) {
  switch (MODEL_TYPE) {
    case "landing_page":
      const LANDING_PAGE_SLUG = Item_Value.slug;
      return `${PREVIEW_URL}/discover/${LANDING_PAGE_SLUG}`;

    case "article":
      const ARTICLE_PAGE_SLUG = Item_Value.article_slug;
      return `${PREVIEW_URL}/${ITEM_ID}/${ARTICLE_PAGE_SLUG}`;

    case "author":
      const AUTHOR_PAGE_SLUG = Item_Value.author_slug;
      return `${PREVIEW_URL}/author/${AUTHOR_PAGE_SLUG}`;

    case "tag":
      const TAG_PAGE_SLUG = Item_Value.slug;
      return `${PREVIEW_URL}/tag/${TAG_PAGE_SLUG}`;

    case "treatment_guide":
      const TREATMENT_GUIDE_SLUG = Item_Value.slug;
      return `${PREVIEW_URL}/${ITEM_ID}/${TREATMENT_GUIDE_SLUG}`;

    default:
      return "ERROR";
  }
}
export default get_preview_url;
